export default function makeRequest(url, onData, onResponse, options = {}) {
  fetch(url, { credentials: 'include', ...options })
    .then(response => {
      const contentType = response.headers.get('content-type') || '';
      const isJson = contentType.includes('application/json');

      if (onResponse) onResponse(response);

      if (isJson) {
        return response.json();
      }
      return Promise.resolve([]);
    })
    .catch(() => Promise.resolve([]))
    .then(data => onData(data));
}
